import { snakeCase } from 'lodash';
import { useMemo } from 'react';
import { useLocalStorage } from './use-local-storage';

export enum PrereleaseFeature {
  ShiftStartDateInResourceManagement = 'ShiftStartDateInResourceManagement',
  PaginateAllTask = 'PaginateAllTask',
  InferredProgress = 'InferredProgress',
  Gpt = 'Gpt',
  ProjectListPagination = 'ProjectListPagination',
  ShowSubscriptionPeriodHoursCarryOver = 'ShowSubscriptionPeriodHoursCarryOver',
  CustomReportsExport = 'CustomReportsExport',
  MeetingsAI = 'MeetingsAI',
  AccountsPortfolio = 'AccountsPortfolio',
  CustomerPortal = 'CustomerPortal',
  Spotlight = 'Spotlight',
}

export const allowed_hostnames = [
  'localhost',
  'northstar.nitro.run',
  'bangalore.nitro.run',
  'testing.nitro.run',
  'rmroles.orbits.run',
  'deepakkumar.nitro.run',
  'report1.orbits.run',
  'report2.orbits.run',
];
const default_meetings_ai_enabled_hostnames = ['success.rocketlane.com'];

export const excluded_features_localhost = window.Cypress
  ? [PrereleaseFeature.PaginateAllTask]
  : [];

export const useFeature = (
  feature: PrereleaseFeature,
  offByDefault = false,
): boolean => {
  const [value] = useLocalStorage(
    `__features.v2.${snakeCase(feature)}`,
    !offByDefault && allowed_hostnames.includes(window.location.hostname),
  );

  // added for cypress - need to remove once the feature is live
  if (window.location.hostname.includes('localhost') && window.Cypress) {
    return !excluded_features_localhost.includes(feature);
  }
  // enable meeting ai by default for success.rocketlane.com
  if (
    feature === PrereleaseFeature.MeetingsAI &&
    default_meetings_ai_enabled_hostnames.includes(window.location.hostname)
  ) {
    return true;
  }

  return value;
};

export const useIsCustomerPortalEnabled = () => {
  return useMemo(() => true, []);
};
